/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoToggleStickyNoteInput = {
    clientMutationId?: string | null;
    slug: string;
    isSticky: boolean;
};
export type NotesToggleMutationVariables = {
    input: infoToggleStickyNoteInput;
};
export type NotesToggleMutationResponse = {
    readonly infoToggleStickyNote: {
        readonly clientMutationId: string | null;
    } | null;
};
export type NotesToggleMutation = {
    readonly response: NotesToggleMutationResponse;
    readonly variables: NotesToggleMutationVariables;
};



/*
mutation NotesToggleMutation(
  $input: infoToggleStickyNoteInput!
) {
  infoToggleStickyNote(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoToggleStickyNotePayload",
    "kind": "LinkedField",
    "name": "infoToggleStickyNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotesToggleMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotesToggleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e67fbbf7f22f6a7e37f7d81a22d384b8",
    "id": null,
    "metadata": {},
    "name": "NotesToggleMutation",
    "operationKind": "mutation",
    "text": "mutation NotesToggleMutation(\n  $input: infoToggleStickyNoteInput!\n) {\n  infoToggleStickyNote(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '62e513bb0c4ccb109e4ea0e7ed4226c5';
export default node;
